import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

export function Checkbox({ label, className, ...rest }: CheckboxProps): JSX.Element {
  return (
    <label className={cn("inline-flex items-center gap-2 text-sm text-zinc-700", className)}>
      <input
        type="checkbox"
        className="h-4 w-4 rounded border-zinc-300 text-brand-500 focus:ring-2 focus:ring-brand-500/20"
        {...rest}
      />
      {label ? <span>{label}</span> : null}
    </label>
  );
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: { value: string; label: string }[];
}

export function Select({ options, className, ...rest }: SelectProps): JSX.Element {
  return (
    <select
      className={cn(
        "h-10 rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900",
        "focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20",
        className,
      )}
      {...rest}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
